export default class AdditionalRequirement {
	constructor(element) {
		this.element = element;
		this.input = element.querySelector('input');
		this.saveChecked();
	}

	toggleHidden(expression_result) {
		this.element.classList.toggle('hidden', expression_result);

		if (expression_result) {
			this.saveChecked();
			this.input.checked = false;
		}
	}

	saveChecked() {
		if (this.previousChecked != this.input.checked) {
			this.previousChecked = this.input.checked;
		}
	}
}
